import Modal from '@mui/material/Modal';
import { Box, Typography } from '@mui/material';
import MuiButton from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 550,
    bgcolor: '#fff',
    boxShadow: 24,
    pt: 4,
    px: 10,
    pb: 3,
    boxSizing:'border-box',
    "@media (max-width: 768px)" : {
        width:"92vw",
        top: '35%',
    }
};

const AlertModal = ({ open, handleClose, content }) => {
    const classes = useStyles();

    const Button = styled(MuiButton)((props) => ({
        borderRadius: "10vw",
        background: "#009A88",
        whiteSpace: "nowrap",
    }));
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{ ...style, borderRadius: "0.5rem", boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)" }} >
                    <Typography
                        sx={{
                            fontSize: { sm: '14px', lg: '18px' },
                            fontWeight: 400,
                            color: "#797979"
                        }}
                    >{content}</Typography>
                    <Button
                        className={classes.button}
                        sx={{
                            padding: { sm: "5px 30px", lg: "10px 40px" },
                            minWidth: { lg: "190px" },
                            margin:{sm: "0 auto", lg :"10px auto 0"}
                        }}
                        onClick={()=>handleClose()}
                    >
                        <Typography
                            className="text"
                            fontSize={{ sm: "14px", md: "2.5vw", lg: "18px" }}
                            sx={{ lineHeight: "21px", fontWeight: "900" }}
                            textTransform={"unset"}
                        >
                            Close
                        </Typography>
                    </Button>
                </Box>
            </Modal>
        </div>
    );
};

export default AlertModal;

const useStyles = makeStyles((theme) => ({
    button: {
        transition: "all .1s ease-in-out",
        border: "3px solid #009A88 !important",
        color:"#fff !important",
        boxSizing:"border-box",
        display: "block !important",
        "&:hover": {
          background: "transparent",
          // transform: "scale(1.05, 1.05)",
          animation: "$scale .2s ease-in-out",
        //   border: "3px solid #009A88",
          color: "#009A88 !important",
        },
      },
    "@keyframes scale": {
        "0%": {
            transform: "scale(1, 1)",
            //animation: "$scale .2s ease-in-out",
        },
        "50%": {
            transform: "scale(1.03, 1.03)",
        },
        "100%": {
            transform: "scale(1)",
        },
    },
    "@media (max-width: 768px)": {
        back: {
            top: "10%",
            left: "0"
        },
    },
}));
